/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import { Accordion, Col, Container, Nav, Navbar, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import FaqComponent from "../Component/FaqComponent/index";
import NativeEventButton from "../Component/NativeEventButton";

import { dataAction } from "../state";
import {
  ContactHeaderText,
  ContainerArcks,
  HeaderText,
  ImgContainer,
  ResultCard,
  ResultCardSectionMargin,
  ResultCardText,
  ResultCardTop,
  RowCol,
  SectionMargin,
  Text,
  ContactSubtext,
  RequiredDocText,
  RequiredDocSubtext,
  PartnerSubtext,
  ResultCardHeaderSection,
  AnimationSection,
  ContactButton,
  Subtext,
} from "./styled/result";
import "./styled/result.scss";
import { CircleCheck } from "../Assets/Images/CircleCheck";
import Logo from "../Assets/Images/Logo";
import ChatIcon from "../Assets/Images/ChatIcon";
import { UniversitySlider } from "../Component/UniversitySlider";
import { ButtonComponent } from "../Component/ButtonComponent";
import { SuccessAnimation } from "../Component/SuccessAnimation/SuccessAnimation";
import { getIELTSTestResults } from "../Component/IELTS/ieltsUserData";

export default function ResultIelts() {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  let { language } = useParams();
  const [lang, setlang] = React.useState(language);
  const [showWorkshopPopup, setShowWorkshopPopup] = React.useState(false);
  const [ieltsResults, setIeltsResults] = React.useState(null);
  const [showIeltsResults, setShowIeltsResults] = React.useState(false);
  const [debugInfo, setDebugInfo] = React.useState({});

  console.log("🔵 [ResultIelts] Component Mounting");
  console.log("📍 Location State:", location.state);

  let search = window.location.search;
  let params = new URLSearchParams(search);
  let utm_source = params.get("utm_source");
  let utm_content = params.get("utm_content");
  let utm_medium = params.get("utm_medium");
  let utm_campaign = params.get("utm_campaign");
  let utm_term = params.get("utm_term");
  const router = useLocation();
  localStorage.setItem("query", router.search);
  const query = localStorage.getItem("query");

  const docRequired = [
    {
      Bachlors: [
        t("common:requiredDocBachlor1"),
        t("common:requiredDocBachlor2"),
        t("common:requiredDocBachlor3"),
      ],
    },
    {
      Masters: [
        t("common:requiredDocMaster1"),
        t("common:requiredDocMaster2"),
        t("common:requiredDocMaster3"),
        t("common:requiredDocMaster4"),
        t("common:requiredDocMaster5"),
        t("common:requiredDocMaster6"),
      ],
    },
    {
      phd: [
        t("common:requiredDocPhd1"),
        t("common:requiredDocPhd2"),
        t("common:requiredDocPhd3"),
        t("common:requiredDocPhd4"),
        t("common:requiredDocPhd5"),
        t("common:requiredDocPhd6"),
        t("common:requiredDocPhd7"),
        t("common:requiredDocPhd8"),
        t("common:requiredDocPhd9"),
      ],
    },
  ];

  const dispatch = useDispatch();
  const { showAnimation } = bindActionCreators(dataAction, dispatch);
  const data = useSelector((state) => state.data);

  React.useEffect(() => {
    console.log("🟢 [ResultIelts] useEffect - Initial Setup");

    window.scroll(0, 0);
    setlang(language);
    i18n.changeLanguage(language);
    document.body.style.overflow = "scroll";
    document.body.style.height = "auto";
    setShowWorkshopPopup(true);

    console.log("🔍 [ResultIelts] Checking localStorage for IELTS results");

    const ieltsTestResults = localStorage.getItem("ieltsTestResults");
    console.log(
      "📍 ieltsTestResults:",
      ieltsTestResults ? JSON.parse(ieltsTestResults) : null,
    );

    const results = getIELTSTestResults();
    console.log("📍 getIELTSTestResults() returned:", results);

    if (results) {
      console.log("✅ [ResultIelts] IELTS Results found!");
      console.log("📊 Full Results Object:", JSON.stringify(results, null, 2));

      const totalCorrect =
        (results.scores?.reading?.correct || 0) +
        (results.scores?.listening?.correct || 0);
      const totalIncorrect =
        (results.scores?.reading?.incorrect || 0) +
        (results.scores?.listening?.incorrect || 0);
      const totalSkipped =
        (results.scores?.reading?.skipped || 0) +
        (results.scores?.listening?.skipped || 0);
      const totalQuestions =
        (results.scores?.reading?.total || 0) +
        (results.scores?.listening?.total || 0);

      console.log("📊 Calculated Totals:");
      console.log("  - Total Correct:", totalCorrect);
      console.log("  - Total Incorrect:", totalIncorrect);
      console.log("  - Total Skipped:", totalSkipped);
      console.log("  - Total Questions:", totalQuestions);

      setIeltsResults(results);
      setShowIeltsResults(true);

      setDebugInfo({
        hasResults: true,
        totalCorrect,
        totalIncorrect,
        totalSkipped,
        totalQuestions,
        overallBand: results.scores?.overall?.bandScore,
        aiEvaluated: results.aiEvaluated,
      });
    } else {
      console.log("❌ [ResultIelts] No IELTS Results found");
      setDebugInfo({
        hasResults: false,
        locationState: location.state,
      });
    }
  }, []);

  const getBandColor = (band) => {
    if (band >= 7.5) return "#4caf50";
    if (band >= 6.5) return "#2196f3";
    if (band >= 5.5) return "#ff9800";
    return "#f44336";
  };

  const getBandDescription = (band) => {
    if (band >= 8.5) return "Expert User";
    if (band >= 7.5) return "Very Good User";
    if (band >= 6.5) return "Good User";
    if (band >= 5.5) return "Competent User";
    if (band >= 4.5) return "Modest User";
    return "Limited User";
  };

  const calculateMetrics = () => {
    if (!ieltsResults?.scores) {
      return {
        totalCorrect: 0,
        totalIncorrect: 0,
        totalSkipped: 0,
        totalQuestions: 0,
        timeTaken: "0 min 0 sec",
        percentage: 0,
        readingCorrect: 0,
        listeningCorrect: 0,
        readingBand: 0,
        listeningBand: 0,
        writingBand: 0,
        overallBand: 0,
      };
    }

    const reading = ieltsResults.scores.reading || {};
    const listening = ieltsResults.scores.listening || {};
    const writing = ieltsResults.scores.writing || {};
    const overall = ieltsResults.scores.overall || {};

    const totalCorrect = (reading.correct || 0) + (listening.correct || 0);
    const totalIncorrect =
      (reading.incorrect || 0) + (listening.incorrect || 0);
    const totalSkipped = (reading.skipped || 0) + (listening.skipped || 0);
    const totalQuestions = (reading.total || 0) + (listening.total || 0);
    const percentage =
      totalQuestions > 0
        ? Math.round((totalCorrect / totalQuestions) * 100)
        : 0;

    return {
      totalCorrect,
      totalIncorrect,
      totalSkipped,
      totalQuestions,
      timeTaken: ieltsResults.timeTaken?.formatted || "0 min 0 sec",
      percentage,
      readingCorrect: reading.correct || 0,
      listeningCorrect: listening.correct || 0,
      readingBand: reading.bandScore || 0,
      listeningBand: listening.bandScore || 0,
      writingBand: writing.bandScore || 0,
      overallBand: overall.bandScore || 0,
      readingTotal: reading.total || 0,
      listeningTotal: listening.total || 0,
    };
  };

  const metrics = calculateMetrics();

  // Dynamic Performance Graph Component
  const PerformanceGraph = () => {
    const maxBarHeight = 80;
    const correctHeight =
      metrics.totalQuestions > 0
        ? (metrics.totalCorrect / metrics.totalQuestions) * maxBarHeight
        : 0;
    const incorrectHeight =
      metrics.totalQuestions > 0
        ? (metrics.totalIncorrect / metrics.totalQuestions) * maxBarHeight
        : 0;
    const skippedHeight =
      metrics.totalQuestions > 0
        ? (metrics.totalSkipped / metrics.totalQuestions) * maxBarHeight
        : 0;

    return (
      <div
        style={{
          background: "#ffffff",
          borderRadius: "16px",
          padding: "24px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          marginBottom: "30px",
        }}
      >
        <h3
          style={{
            fontSize: "20px",
            fontWeight: "600",
            color: "#333",
            marginBottom: "20px",
            textAlign: "left",
          }}
        >
          {t("common:performanceRating") || "Your Performance Rating"}
        </h3>

        {/* Score Circle */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "30px",
          }}
        >
          <div
            style={{
              width: "120px",
              height: "120px",
              borderRadius: "50%",
              background: `linear-gradient(135deg, ${getBandColor(metrics.overallBand)} 0%, ${getBandColor(metrics.overallBand)}80 100%)`,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
            }}
          >
            <span
              style={{ fontSize: "42px", fontWeight: "bold", lineHeight: 1 }}
            >
              {metrics.overallBand.toFixed(1)}
            </span>
            <span style={{ fontSize: "14px", opacity: 0.9 }}>
              {t("common:estimatedBand") || "Estimated Band"}
            </span>
          </div>
        </div>

        {/* Metrics Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "16px",
            marginBottom: "30px",
          }}
        >
          <div
            style={{
              background: "#f8f9fa",
              padding: "16px",
              borderRadius: "12px",
              textAlign: "center",
            }}
          >
            <div
              style={{ fontSize: "14px", color: "#666", marginBottom: "8px" }}
            >
              {t("common:timeTaken") || "Time taken"}
            </div>
            <div style={{ fontSize: "18px", fontWeight: "600", color: "#333" }}>
              {metrics.timeTaken}
            </div>
          </div>

          <div
            style={{
              background: "#f8f9fa",
              padding: "16px",
              borderRadius: "12px",
              textAlign: "center",
            }}
          >
            <div
              style={{ fontSize: "14px", color: "#666", marginBottom: "8px" }}
            >
              {t("common:correctAnswers") || "Correct Answers"}
            </div>
            <div
              style={{ fontSize: "18px", fontWeight: "600", color: "#4caf50" }}
            >
              {metrics.totalCorrect}
            </div>
          </div>

          <div
            style={{
              background: "#f8f9fa",
              padding: "16px",
              borderRadius: "12px",
              textAlign: "center",
            }}
          >
            <div
              style={{ fontSize: "14px", color: "#666", marginBottom: "8px" }}
            >
              {t("common:incorrectAnswers") || "Incorrect Answers"}
            </div>
            <div
              style={{ fontSize: "18px", fontWeight: "600", color: "#f44336" }}
            >
              {metrics.totalIncorrect}
            </div>
          </div>

          <div
            style={{
              background: "#f8f9fa",
              padding: "16px",
              borderRadius: "12px",
              textAlign: "center",
            }}
          >
            <div
              style={{ fontSize: "14px", color: "#666", marginBottom: "8px" }}
            >
              {t("common:skippedQuestions") || "Skipped Questions"}
            </div>
            <div
              style={{ fontSize: "18px", fontWeight: "600", color: "#ff9800" }}
            >
              {metrics.totalSkipped}
            </div>
          </div>
        </div>

        {/* Total Score */}
        <div
          style={{
            textAlign: "center",
            padding: "16px",
            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
            borderRadius: "12px",
            marginBottom: "30px",
          }}
        >
          <span style={{ fontSize: "16px", color: "#666" }}>
            {t("common:yourTotalScore") || "Your Total Score"}:
          </span>
          <span
            style={{
              fontSize: "28px",
              fontWeight: "bold",
              color: "#299CF7",
              marginLeft: "10px",
            }}
          >
            {metrics.totalCorrect}/{metrics.totalQuestions}
          </span>
          <span
            style={{
              fontSize: "16px",
              color: "#999",
              marginLeft: "10px",
            }}
          >
            ({metrics.percentage}%)
          </span>
        </div>

        {/* Graph Bars */}
        <div style={{ marginTop: "20px" }}>
          <h4
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#333",
              marginBottom: "20px",
            }}
          >
            {t("common:performanceBreakdown") || "Performance Breakdown"}
          </h4>

          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "flex-end",
              height: "120px",
            }}
          >
            {/* Correct Bar */}
            <div style={{ textAlign: "center", width: "80px" }}>
              <div
                style={{
                  height: `${correctHeight}px`,
                  width: "40px",
                  background: "#4caf50",
                  borderRadius: "8px 8px 0 0",
                  margin: "0 auto",
                  transition: "height 0.5s ease",
                  position: "relative",
                }}
              >
                <span
                  style={{
                    position: "absolute",
                    top: "-20px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#4caf50",
                  }}
                >
                  {metrics.totalCorrect}
                </span>
              </div>
              <div
                style={{ marginTop: "8px", fontSize: "12px", color: "#666" }}
              >
                {t("common:correct") || "Correct"}
              </div>
            </div>

            {/* Incorrect Bar */}
            <div style={{ textAlign: "center", width: "80px" }}>
              <div
                style={{
                  height: `${incorrectHeight}px`,
                  width: "40px",
                  background: "#f44336",
                  borderRadius: "8px 8px 0 0",
                  margin: "0 auto",
                  transition: "height 0.5s ease",
                  position: "relative",
                }}
              >
                <span
                  style={{
                    position: "absolute",
                    top: "-20px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#f44336",
                  }}
                >
                  {metrics.totalIncorrect}
                </span>
              </div>
              <div
                style={{ marginTop: "8px", fontSize: "12px", color: "#666" }}
              >
                {t("common:incorrect") || "Incorrect"}
              </div>
            </div>

            {/* Skipped Bar */}
            <div style={{ textAlign: "center", width: "80px" }}>
              <div
                style={{
                  height: `${skippedHeight}px`,
                  width: "40px",
                  background: "#ff9800",
                  borderRadius: "8px 8px 0 0",
                  margin: "0 auto",
                  transition: "height 0.5s ease",
                  position: "relative",
                }}
              >
                <span
                  style={{
                    position: "absolute",
                    top: "-20px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#ff9800",
                  }}
                >
                  {metrics.totalSkipped}
                </span>
              </div>
              <div
                style={{ marginTop: "8px", fontSize: "12px", color: "#666" }}
              >
                {t("common:skipped") || "Skipped"}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  var degree = localStorage.getItem("degree");
  var qualified = location.state?.qualified;

  return (
    <>
      {/* Workshop Registration Success Modal */}
      <Modal
        show={showWorkshopPopup}
        onHide={() => setShowWorkshopPopup(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body style={{ padding: 0 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "40px 20px",
              textAlign: "center",
            }}
          >
            <SuccessAnimation onComplete={() => {}} />
            <h3
              style={{
                marginTop: "20px",
                fontFamily: i18n.language === "ar" ? "Cairo" : "DM Sans",
                fontWeight: "bold",
                color: "#299CF7",
              }}
            >
              {t("common:workshopRegistrationSuccess")}
            </h3>
            <p
              style={{
                marginTop: "10px",
                fontFamily: i18n.language === "ar" ? "Cairo" : "DM Sans",
                fontSize: "16px",
                color: "#555555",
              }}
            >
              {t("common:workshopRegistrationDetails")}
            </p>
            <ButtonComponent
              label={t("common:close")}
              btnType={"dark"}
              width="200px"
              style={{
                marginTop: "30px",
                height: "50px",
                fontFamily: i18n.language === "ar" ? "Cairo" : "Dm Sans",
              }}
              onClick={() => setShowWorkshopPopup(false)}
            />
          </div>
        </Modal.Body>
      </Modal>

      {/* IELTS Results Modal */}
      <Modal
        show={showIeltsResults}
        onHide={() => setShowIeltsResults(false)}
        centered
        size="lg"
        backdrop="static"
      >
        <Modal.Body style={{ padding: 0 }}>
          <div
            style={{
              padding: "30px",
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            {/* Debug Info - Only in development */}
            {process.env.NODE_ENV === "development" && (
              <div
                style={{
                  background: "#f0f0f0",
                  padding: "10px",
                  marginBottom: "20px",
                  borderRadius: "5px",
                  fontSize: "12px",
                  fontFamily: "monospace",
                }}
              >
                <strong>Debug Info:</strong>
                <pre>{JSON.stringify(debugInfo, null, 2)}</pre>
                <pre>{JSON.stringify(metrics, null, 2)}</pre>
              </div>
            )}

            <div style={{ textAlign: "center", marginBottom: "30px" }}>
              <SuccessAnimation onComplete={() => {}} />
              <h2
                style={{
                  marginTop: "20px",
                  fontFamily: i18n.language === "ar" ? "Cairo" : "DM Sans",
                  fontWeight: "bold",
                  color: "#299CF7",
                }}
              >
                {t("common:ieltsTestCompleted") || "IELTS Test Completed!"}
              </h2>
            </div>

            {ieltsResults ? (
              <>
                {/* Performance Graph Component */}
                <PerformanceGraph />

                {/* Section Scores */}
                <div className="row" style={{ marginBottom: "30px" }}>
                  <div className="col-md-4 mb-3">
                    <div
                      style={{
                        background: "#f8f9fa",
                        borderRadius: "10px",
                        padding: "20px",
                        textAlign: "center",
                        border: "1px solid #e9ecef",
                      }}
                    >
                      <h4 style={{ color: "#299CF7", marginBottom: "15px" }}>
                        {t("common:reading") || "Reading"}
                      </h4>
                      <div
                        style={{
                          fontSize: "36px",
                          fontWeight: "bold",
                          color: getBandColor(metrics.readingBand),
                        }}
                      >
                        {metrics.readingBand.toFixed(1)}
                      </div>
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#6c757d",
                          marginTop: "10px",
                        }}
                      >
                        {metrics.readingCorrect}/{metrics.readingTotal} correct
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <div
                      style={{
                        background: "#f8f9fa",
                        borderRadius: "10px",
                        padding: "20px",
                        textAlign: "center",
                        border: "1px solid #e9ecef",
                      }}
                    >
                      <h4 style={{ color: "#299CF7", marginBottom: "15px" }}>
                        {t("common:listening") || "Listening"}
                      </h4>
                      <div
                        style={{
                          fontSize: "36px",
                          fontWeight: "bold",
                          color: getBandColor(metrics.listeningBand),
                        }}
                      >
                        {metrics.listeningBand.toFixed(1)}
                      </div>
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#6c757d",
                          marginTop: "10px",
                        }}
                      >
                        {metrics.listeningCorrect}/{metrics.listeningTotal}{" "}
                        correct
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <div
                      style={{
                        background: "#f8f9fa",
                        borderRadius: "10px",
                        padding: "20px",
                        textAlign: "center",
                        border: "1px solid #e9ecef",
                      }}
                    >
                      <h4 style={{ color: "#299CF7", marginBottom: "15px" }}>
                        {t("common:writing") || "Writing"}
                      </h4>
                      <div
                        style={{
                          fontSize: "36px",
                          fontWeight: "bold",
                          color: getBandColor(metrics.writingBand),
                        }}
                      >
                        {metrics.writingBand.toFixed(1)}
                      </div>
                      {ieltsResults.aiEvaluated && (
                        <span
                          style={{
                            fontSize: "12px",
                            background: "#4caf50",
                            color: "white",
                            padding: "3px 8px",
                            borderRadius: "12px",
                            display: "inline-block",
                            marginTop: "10px",
                          }}
                        >
                          AI Evaluated
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Writing Detailed Feedback */}
                {ieltsResults.scores?.writing?.details && (
                  <div style={{ marginBottom: "30px" }}>
                    <h4 style={{ color: "#299CF7", marginBottom: "20px" }}>
                      {t("common:writingFeedback") || "Writing Feedback"}
                    </h4>

                    {/* Task 1 Feedback */}
                    {ieltsResults.scores.writing.details.task1 && (
                      <div
                        style={{
                          background: "#f8f9fa",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "20px",
                          border: "1px solid #e9ecef",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "15px",
                          }}
                        >
                          <h5 style={{ color: "#299CF7", margin: 0 }}>
                            {t("common:task1") || "Task 1"}
                            <span
                              style={{
                                fontSize: "14px",
                                color: "#6c757d",
                                marginLeft: "10px",
                              }}
                            >
                              (
                              {ieltsResults.scores.writing.details.task1
                                .wordCount || 0}{" "}
                              words)
                            </span>
                          </h5>
                          <div
                            style={{
                              background: getBandColor(
                                ieltsResults.scores.writing.details.task1
                                  .bandScore,
                              ),
                              color: "white",
                              padding: "5px 15px",
                              borderRadius: "20px",
                              fontWeight: "bold",
                            }}
                          >
                            Band{" "}
                            {
                              ieltsResults.scores.writing.details.task1
                                .bandScore
                            }
                          </div>
                        </div>

                        {/* Criteria Breakdown */}
                        {ieltsResults.scores.writing.details.task1.criteria && (
                          <div style={{ marginBottom: "15px" }}>
                            {Object.entries(
                              ieltsResults.scores.writing.details.task1
                                .criteria,
                            ).map(([key, value]) => (
                              <div key={key} style={{ marginBottom: "10px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: "5px",
                                  }}
                                >
                                  <span
                                    style={{ fontWeight: "500", color: "#333" }}
                                  >
                                    {key.replace(/([A-Z])/g, " $1").trim()}
                                  </span>
                                  <span
                                    style={{
                                      color: getBandColor(value.band),
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Band {value.band}
                                  </span>
                                </div>
                                <p
                                  style={{
                                    fontSize: "14px",
                                    color: "#555",
                                    margin: 0,
                                  }}
                                >
                                  {value.feedback}
                                </p>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* Summary */}
                        {ieltsResults.scores.writing.details.task1.summary && (
                          <div style={{ marginBottom: "15px" }}>
                            <p style={{ fontStyle: "italic", color: "#555" }}>
                              {
                                ieltsResults.scores.writing.details.task1
                                  .summary
                              }
                            </p>
                          </div>
                        )}

                        {/* Improvement Suggestions */}
                        {ieltsResults.scores.writing.details.task1
                          .improvements && (
                          <div>
                            <h6
                              style={{ color: "#ff9800", marginBottom: "10px" }}
                            >
                              {t("common:suggestions") ||
                                "Suggestions for Improvement"}
                              :
                            </h6>
                            <ul style={{ margin: 0, paddingLeft: "20px" }}>
                              {ieltsResults.scores.writing.details.task1.improvements.map(
                                (suggestion, idx) => (
                                  <li
                                    key={idx}
                                    style={{
                                      fontSize: "14px",
                                      color: "#555",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    {suggestion}
                                  </li>
                                ),
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Task 2 Feedback */}
                    {ieltsResults.scores.writing.details.task2 && (
                      <div
                        style={{
                          background: "#f8f9fa",
                          borderRadius: "10px",
                          padding: "20px",
                          border: "1px solid #e9ecef",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "15px",
                          }}
                        >
                          <h5 style={{ color: "#299CF7", margin: 0 }}>
                            {t("common:task2") || "Task 2"}
                            <span
                              style={{
                                fontSize: "14px",
                                color: "#6c757d",
                                marginLeft: "10px",
                              }}
                            >
                              (
                              {ieltsResults.scores.writing.details.task2
                                .wordCount || 0}{" "}
                              words)
                            </span>
                          </h5>
                          <div
                            style={{
                              background: getBandColor(
                                ieltsResults.scores.writing.details.task2
                                  .bandScore,
                              ),
                              color: "white",
                              padding: "5px 15px",
                              borderRadius: "20px",
                              fontWeight: "bold",
                            }}
                          >
                            Band{" "}
                            {
                              ieltsResults.scores.writing.details.task2
                                .bandScore
                            }
                          </div>
                        </div>

                        {/* Criteria Breakdown */}
                        {ieltsResults.scores.writing.details.task2.criteria && (
                          <div style={{ marginBottom: "15px" }}>
                            {Object.entries(
                              ieltsResults.scores.writing.details.task2
                                .criteria,
                            ).map(([key, value]) => (
                              <div key={key} style={{ marginBottom: "10px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: "5px",
                                  }}
                                >
                                  <span
                                    style={{ fontWeight: "500", color: "#333" }}
                                  >
                                    {key.replace(/([A-Z])/g, " $1").trim()}
                                  </span>
                                  <span
                                    style={{
                                      color: getBandColor(value.band),
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Band {value.band}
                                  </span>
                                </div>
                                <p
                                  style={{
                                    fontSize: "14px",
                                    color: "#555",
                                    margin: 0,
                                  }}
                                >
                                  {value.feedback}
                                </p>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* Summary */}
                        {ieltsResults.scores.writing.details.task2.summary && (
                          <div style={{ marginBottom: "15px" }}>
                            <p style={{ fontStyle: "italic", color: "#555" }}>
                              {
                                ieltsResults.scores.writing.details.task2
                                  .summary
                              }
                            </p>
                          </div>
                        )}

                        {/* Improvement Suggestions */}
                        {ieltsResults.scores.writing.details.task2
                          .improvements && (
                          <div>
                            <h6
                              style={{ color: "#ff9800", marginBottom: "10px" }}
                            >
                              {t("common:suggestions") ||
                                "Suggestions for Improvement"}
                              :
                            </h6>
                            <ul style={{ margin: 0, paddingLeft: "20px" }}>
                              {ieltsResults.scores.writing.details.task2.improvements.map(
                                (suggestion, idx) => (
                                  <li
                                    key={idx}
                                    style={{
                                      fontSize: "14px",
                                      color: "#555",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    {suggestion}
                                  </li>
                                ),
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {/* Test Information */}
                <div
                  style={{
                    background: "#f8f9fa",
                    borderRadius: "10px",
                    padding: "20px",
                    border: "1px solid #e9ecef",
                    fontSize: "14px",
                    color: "#555",
                  }}
                >
                  <h5 style={{ color: "#299CF7", marginBottom: "15px" }}>
                    {t("common:testInformation") || "Test Information"}
                  </h5>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "10px",
                    }}
                  >
                    <div>
                      <strong>{t("common:name") || "Name"}:</strong>{" "}
                      {ieltsResults.name || "N/A"}
                    </div>
                    <div>
                      <strong>{t("common:email") || "Email"}:</strong>{" "}
                      {ieltsResults.email || "N/A"}
                    </div>
                    <div>
                      <strong>{t("common:phone") || "Phone"}:</strong>{" "}
                      {ieltsResults.phone || "N/A"}
                    </div>
                    <div>
                      <strong>{t("common:completedAt") || "Completed"}:</strong>{" "}
                      {ieltsResults.completedAt
                        ? new Date(
                            ieltsResults.completedAt,
                          ).toLocaleDateString()
                        : "N/A"}
                    </div>
                    <div>
                      <strong>{t("common:evaluation") || "Evaluation"}:</strong>{" "}
                      {ieltsResults.aiEvaluated ? "AI Powered" : "Basic"}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div style={{ textAlign: "center", padding: "40px" }}>
                <p>No IELTS results found</p>
              </div>
            )}

            <div className="d-flex justify-content-center mt-4">
              <ButtonComponent
                label={t("common:close") || "Close"}
                btnType={"dark"}
                width="200px"
                style={{ height: "50px" }}
                onClick={() => setShowIeltsResults(false)}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Navbar collapseOnSelect expand="lg" sticky="top">
        <Container>
          <a
            target="_blank"
            href={"https://wa.me/96566687847"}
            rel="noreferrer"
          >
            <img
              className="mobile-view"
              style={{ width: 28, height: 28 }}
              src="/img/legacy/WhatsApp_Logo_1-1.png"
              alt="icon"
            />
          </a>
          <Navbar.Brand href="#home">
            <Logo />
          </Navbar.Brand>
          <Navbar.Toggle className="mobile-view">
            <svg
              className="d-flex justify-content-end "
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="2.66667" cy="2.66667" r="2.66667" fill="black" />
              <circle cx="2.66667" cy="13.3332" r="2.66667" fill="black" />
              <circle cx="13.3332" cy="13.3332" r="2.66667" fill="black" />
              <circle cx="13.3332" cy="2.66667" r="2.66667" fill="black" />
            </svg>
          </Navbar.Toggle>
          <Navbar.Collapse className="justify-content-center">
            <Nav.Link
              style={{ display: "none" }}
              href={utm_source ? `/apply${query}` : "/apply"}
            >
              apply{" "}
            </Nav.Link>
            <Nav.Link href="https://g.page/Ulearn-study-abroad">
              لوكيشن المكتب
            </Nav.Link>
            <Nav.Link href={utm_source ? `/career${query}` : "/career"}>
              اختبار تحديد التخصص{" "}
            </Nav.Link>
            <div className="mobile-view" style={{ padding: "0 15px " }}>
              <NativeEventButton
                className="btn-primary calendly-btn"
                utm={{
                  utmCampaign: utm_campaign,
                  utmContent: utm_content,
                  utmMedium: utm_medium,
                  utmSource: utm_source,
                  utmTerm: utm_term,
                }}
                text="احجز موعد استشارة هاتفية مجانية"
              />
            </div>
          </Navbar.Collapse>

          <div className=" pc-view" style={{ padding: "0 15px " }}>
            <NativeEventButton
              className="btn-primary calendly-btn d-flex justify-content-end"
              utm={{
                utmCampaign: utm_campaign,
                utmContent: utm_content,
                utmMedium: utm_medium,
                utmSource: utm_source,
                utmTerm: utm_term,
              }}
              text="احجز موعد استشارة هاتفية مجانية"
            />
          </div>
        </Container>
      </Navbar>

      {data.show ? (
        <AnimationSection>
          <SuccessAnimation
            onComplete={async () => {
              showAnimation(false);
            }}
          />
        </AnimationSection>
      ) : null}

      <Container>
        <ResultCardHeaderSection>
          <HeaderText arabic={i18n.language === "ar"}>
            {t("common:applicationSubmitted")}
          </HeaderText>
          <Subtext
            arabic={i18n.language === "ar"}
            fontSize="16px"
            textAlign="center"
          >
            {t("common:applicationSubmittedSubtext")}
          </Subtext>
        </ResultCardHeaderSection>

        <ResultCardSectionMargin className="d-flex justify-content-center">
          <ResultCard>
            <ResultCardTop className="d-flex justify-content-center align-items-center">
              <svg
                width="58"
                height="15"
                viewBox="0 0 58 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.0582 14.7952C15.5364 14.7952 16.0977 14.692 16.6591 14.4855V12.5035C16.368 12.5861 16.0977 12.6273 15.869 12.6273C15.4117 12.6273 15.1414 12.4415 15.1414 11.9873V0.198242H12.6465V12.1525C12.6465 13.9694 13.6652 14.7952 15.0582 14.7952Z"
                  fill="white"
                />
                <path
                  d="M27.269 9.36522C27.269 6.53667 25.7305 4.20363 22.5495 4.20363C19.1399 4.20363 17.6845 6.88766 17.6845 9.55104C17.6845 12.2764 19.1814 14.7952 22.7159 14.7952C24.4415 14.7952 25.7929 14.1965 26.9156 12.9577L25.19 11.4505C24.4831 12.2557 23.6514 12.5448 22.7366 12.5448C21.115 12.5448 20.2833 11.657 20.1794 10.315H27.2067C27.2482 9.98461 27.269 9.67492 27.269 9.36522ZM20.1586 8.35355C20.3041 7.34188 21.011 6.26827 22.5287 6.26827C23.8386 6.26827 24.8365 7.05283 24.8781 8.35355H20.1586Z"
                  fill="white"
                />
                <path
                  d="M33.2891 4.20363C31.4179 4.20363 29.9002 4.92626 28.6735 6.39215L30.4823 7.89933C31.2308 6.90831 32.208 6.3715 33.2475 6.3715C34.4326 6.3715 35.181 7.05283 35.181 8.16773V8.45678H32.6238C31.4595 8.45678 30.5863 8.60131 29.9002 8.911C28.9022 9.36522 28.3617 10.2737 28.3617 11.4712C28.3617 13.4119 29.9002 14.7952 32.0624 14.7952C33.4138 14.7952 34.5781 14.2171 35.181 13.2674L35.3889 14.5887H37.6759V8.16773C37.6759 5.71082 35.9919 4.20363 33.2891 4.20363ZM32.4575 12.6893C31.4595 12.6893 30.8566 12.2351 30.8566 11.5124C30.8566 11.1408 31.0021 10.8518 31.2724 10.6659C31.605 10.4182 32.104 10.315 32.9564 10.315H35.181C35.181 11.6363 33.9544 12.6893 32.4575 12.6893Z"
                  fill="white"
                />
                <path
                  d="M45.5623 4.20363C44.398 4.20363 43.2545 4.88496 42.8179 6.14439V4.4101H40.3022V14.5887H42.7971V9.46846C42.7971 7.54834 43.5456 6.61926 45.0633 6.61926C45.5623 6.61926 45.9573 6.74314 46.3107 6.97025L47.5166 4.78173C46.8513 4.36881 46.2484 4.20363 45.5623 4.20363Z"
                  fill="white"
                />
                <path
                  d="M54.3818 4.20363C53.1343 4.20363 52.0116 4.61656 51.2839 5.58694V4.4101H48.7891V14.5887H51.2839V10.5214C51.2839 8.70454 51.2839 6.3715 53.6125 6.3715C55.5045 6.3715 55.5045 7.94062 55.5045 8.6426V14.5887H57.9994V8.02321C57.9994 5.60759 56.6895 4.20363 54.3818 4.20363Z"
                  fill="white"
                />
                <path
                  d="M8.2379 2.05519L8.28384 2.10081C8.75728 2.57097 9.52488 2.57097 9.99832 2.10082C10.4718 1.63067 10.4718 0.868401 9.99832 0.398249L9.95237 0.352613C9.47893 -0.117539 8.71133 -0.117538 8.23789 0.352615C7.76445 0.822768 7.76446 1.58504 8.2379 2.05519Z"
                  fill="white"
                />
                <path
                  d="M1.23638 0.00291063L2.26599 2.45914H0.204819L1.23638 0.00291063Z"
                  fill="white"
                  stroke="black"
                  strokeWidth="0.00225225"
                />
                <path
                  d="M0 4.37402L0.00892996 9.70117C0.00892996 11.1158 0.504424 12.3152 1.49541 13.2993C2.49879 14.2834 3.72514 14.7755 5.17446 14.7755C6.63616 14.7755 7.86251 14.2834 8.8535 13.2993C9.85688 12.3152 10.3586 11.1158 10.3586 9.70117L10.3496 4.37402H7.87836L7.87835 9.70117C7.87835 10.4885 7.63335 11.042 7.12546 11.5833C6.61758 12.1122 5.96725 12.3767 5.17446 12.3767C4.38167 12.3767 3.73133 12.1122 3.22345 11.5833C2.72795 11.042 2.47127 10.5008 2.47127 9.70117L2.47128 4.37402H0Z"
                  fill="white"
                />
              </svg>
            </ResultCardTop>

            <div>
              <RequiredDocText arabic={i18n.language === "ar"}>
                {t("common:requiredDoc")}
              </RequiredDocText>
              <RequiredDocSubtext arabic={i18n.language === "ar"}>
                {t("common:toPursue")}{" "}
                <span style={{ fontWeight: 900 }}>
                  {i18n.language === "ar"
                    ? location.state?.degree?.ar_name
                    : location.state?.degree?.en_name}
                </span>{" "}
                {t("common:degreeinUK")}
              </RequiredDocSubtext>
            </div>

            <div
              style={{
                borderTop: "1px solid #E8E9F5",
                borderBottom: "1px solid #E8E9F5",
                padding: "14px 0",
                margin: "9px 0 30px 0",
              }}
            >
              {degree === "Bachelor's"
                ? docRequired[0].Bachlors?.map((x) => (
                    <div
                      key={x}
                      className="d-flex flex-row align-items-start"
                      style={{
                        direction: i18n.language === "ar" ? "rtl" : "ltr",
                        marginBottom: 11,
                      }}
                    >
                      <div>
                        <CircleCheck
                          style={{
                            margin:
                              i18n.language === "en"
                                ? "0 10px 0 0"
                                : "0 0 0 10px",
                          }}
                        />
                      </div>
                      <ResultCardText arabic={i18n.language === "ar"}>
                        {x}
                      </ResultCardText>
                    </div>
                  ))
                : degree === "Master's"
                  ? docRequired[1].Masters?.map((x) => (
                      <div
                        key={x}
                        className="d-flex flex-row align-items-start"
                        style={{
                          direction: i18n.language === "ar" ? "rtl" : "ltr",
                          marginBottom: 5,
                        }}
                      >
                        <div>
                          <CircleCheck
                            style={{
                              margin:
                                i18n.language === "en"
                                  ? "0 10px 0 0"
                                  : "0 0 0 10px",
                            }}
                          />
                        </div>
                        <ResultCardText arabic={i18n.language === "ar"}>
                          {x}
                        </ResultCardText>
                      </div>
                    ))
                  : degree === "PhD"
                    ? docRequired[2].phd?.map((x) => (
                        <div
                          key={x}
                          className="d-flex flex-row align-items-start"
                          style={{
                            direction: i18n.language === "ar" ? "rtl" : "ltr",
                            marginBottom: 5,
                          }}
                        >
                          <div>
                            <CircleCheck
                              style={{
                                margin:
                                  i18n.language === "en"
                                    ? "0 10px 0 0"
                                    : "0 0 0 10px",
                              }}
                            />
                          </div>
                          <ResultCardText arabic={i18n.language === "ar"}>
                            {x}
                          </ResultCardText>
                        </div>
                      ))
                    : null}
            </div>

            {qualified ? (
              <div
                className="d-flex justify-content-center"
                style={{ zIndex: 3 }}
              >
                <ButtonComponent
                  label={t("common:sendOnWa")}
                  btnType={"dark"}
                  width="460px"
                  style={{
                    height: 52,
                    zIndex: 99,
                    fontFamily: i18n.language === "ar" ? "Cairo" : "Dm Sans",
                  }}
                  onClick={() => window.open("https://wa.me/96566687847")}
                />
              </div>
            ) : null}
          </ResultCard>
        </ResultCardSectionMargin>

        {/* View Results Button */}
        {ieltsResults && (
          <div className="d-flex justify-content-center mb-4">
            <ButtonComponent
              label={t("common:viewIeltsResults") || "View Your IELTS Results"}
              btnType={"primary"}
              width="300px"
              style={{
                height: 52,
                background: "linear-gradient(135deg, #299CF7 0%, #8BCCFF 100%)",
                border: "none",
                fontFamily: i18n.language === "ar" ? "Cairo" : "Dm Sans",
              }}
              onClick={() => setShowIeltsResults(true)}
            />
          </div>
        )}

        <SectionMargin>
          <HeaderText arabic={i18n.language === "ar"} marginBottom="86px">
            {t("common:services")}
          </HeaderText>

          <RowCol
            pcDirection={i18n.language === "ar" ? "row" : "row-reverse"}
            direction={"column-reverse"}
          >
            <Col md={6} style={{ padding: 0 }}>
              <div className="d-flex justify-content-center">
                <ImgContainer
                  width="548px"
                  height="470px"
                  background={`url("/img/legacy/ulearn-img.png")`}
                />
              </div>
            </Col>
            <Col
              md={6}
              className="d-flex justify-content-center flex-column"
              style={{ padding: 0 }}
            >
              <Subtext
                fontSize="40px"
                textAlign={i18n.language === "ar" ? "right" : "left"}
                lineHeight={"64px"}
                arabic={i18n.language === "ar"}
                className="consaltation-text pc-view"
                direction={i18n.language === "ar" ? "rtl" : "ltr"}
              >
                <b>{t("common:serviceSection1Text1")}</b>
                <br />{" "}
                <b style={{ color: "#299cf7" }}>
                  {t("common:serviceSection1Text2")}
                </b>{" "}
                {t("common:serviceSection1Text3")}
              </Subtext>
              <Subtext
                fontSize="24px"
                textAlign={i18n.language === "ar" ? "right" : "left"}
                lineHeight={"40px"}
                arabic={i18n.language === "ar"}
                className="mobile-view"
                direction={i18n.language === "ar" ? "rtl" : "ltr"}
              >
                <b>{t("common:serviceSection1Text1")}</b>{" "}
                <b style={{ color: "#299cf7" }}>
                  {t("common:serviceSection1Text2")}
                </b>{" "}
                {t("common:serviceSection1Text3")}
              </Subtext>
              <Text
                arabic={i18n.language === "ar"}
                textAlign={i18n.language === "ar" ? "right" : "left"}
                className="consaltation-subtext"
              >
                {t("common:serviceSection1Desc")}
                <br />
                {i18n.language === "ar"
                  ? t("common:serviceSection1Desc2")
                  : null}
              </Text>
              <div
                style={{
                  marginBottom: 30,
                }}
                className="w-100 d-flex justify-content-end"
              ></div>
            </Col>
          </RowCol>

          <RowCol
            direction="column"
            pcDirection={i18n.language === "ar" ? "row" : "row-reverse"}
          >
            <Col
              md={6}
              className="d-flex justify-content-center flex-column"
              style={{ padding: 0 }}
            >
              <Subtext
                fontSize="40px"
                lineHeight={"64px"}
                arabic={i18n.language === "ar"}
                textAlign={i18n.language === "ar" ? "right" : "left"}
                className="consaltation-text pc-view"
                direction={i18n.language === "ar" ? "rtl" : "ltr"}
              >
                <b>{t("common:serviceSection2Text1")}</b>
                <br />{" "}
                <b style={{ color: "#299cf7" }}>
                  {t("common:serviceSection2Text2")}
                </b>
              </Subtext>
              <Subtext
                fontSize="24px"
                lineHeight={"44px"}
                arabic={i18n.language === "ar"}
                textAlign={i18n.language === "ar" ? "right" : "left"}
                className="mobile-view"
                direction={i18n.language === "ar" ? "rtl" : "ltr"}
              >
                <b> {t("common:serviceSection2Text1")}</b>
                <b style={{ color: "#299cf7" }}>
                  {" "}
                  {t("common:serviceSection2Text2")}
                </b>
              </Subtext>
              <Text
                arabic={i18n.language === "ar"}
                textAlign={i18n.language === "ar" ? "right" : "left"}
                className="consaltation-subtext"
              >
                {t("common:serviceSection2Desc")}
                <br />
                {t("common:serviceSection2Desc2")}
              </Text>
              <div
                style={{
                  marginBottom: 30,
                }}
                className="w-100 d-flex justify-content-end"
              ></div>
            </Col>
            <Col md={6} style={{ padding: 0 }}>
              <div className="d-flex justify-content-center">
                <ImgContainer
                  width="560px"
                  height="520px"
                  background={`url("/img/legacy/ulearn-img1.png")`}
                />
              </div>
            </Col>
          </RowCol>

          <RowCol
            pcDirection={i18n.language === "ar" ? "row" : "row-reverse"}
            direction="column-reverse"
          >
            <Col md={6} style={{ padding: 0 }}>
              <div className="d-flex justify-content-center">
                <ImgContainer
                  last
                  width="548px"
                  height="428px"
                  background={`url("/img/legacy/ulearnn-img2.png")`}
                />
              </div>
            </Col>
            <Col
              md={6}
              className="d-flex justify-content-center flex-column"
              style={{ padding: 0 }}
            >
              <Subtext
                fontSize="40px"
                arabic={i18n.language === "ar"}
                textAlign={i18n.language === "ar" ? "right" : "left"}
                lineHeight={"64px"}
                className="consaltation-text pc-view"
                direction={i18n.language === "ar" ? "rtl" : "ltr"}
              >
                {t("common:serviceSection3Text1")}
                <br />{" "}
                <b style={{ color: "#299cf7" }}>
                  {" "}
                  {t("common:serviceSection3Text2")}
                </b>
              </Subtext>
              <Subtext
                fontSize="24px"
                lineHeight={"44px"}
                className="mobile-view"
                arabic={i18n.language === "ar"}
                textAlign={i18n.language === "ar" ? "right" : "left"}
                direction={i18n.language === "ar" ? "rtl" : "ltr"}
              >
                <b style={{ color: "#299cf7" }}>
                  {t("common:serviceSection3Text1")}
                </b>{" "}
                <b>{t("common:serviceSection3Text2")}</b>
              </Subtext>
              <Text
                arabic={i18n.language === "ar"}
                textAlign={i18n.language === "ar" ? "right" : "left"}
                className="consaltation-subtext"
              >
                {t("common:serviceSection3Desc")}
                <br />
                {t("common:serviceSection3Desc2")}
              </Text>
              <div
                style={{
                  marginBottom: 30,
                }}
                className="w-100 d-flex justify-content-end"
              ></div>
            </Col>
          </RowCol>
        </SectionMargin>
      </Container>

      {qualified ? (
        <>
          <SectionMargin className="container pc-view">
            <div
              className="d-flex flex-column align-items-center justify-content-center"
              style={{
                background: "#299cf7",
                padding: "40px 20px",
                borderRadius: 20,
              }}
            >
              <ChatIcon style={{ marginBottom: 24 }} />
              <ContactHeaderText arabic={i18n.language === "ar"}>
                {t("common:contactSection")}
              </ContactHeaderText>
              <ContactSubtext arabic={i18n.language === "ar"}>
                {t("common:contactSectionDesc")}{" "}
              </ContactSubtext>
              <ContactButton
                btnType={"light"}
                width="335px"
                style={{
                  marginTop: 24,
                  height: 56,
                  border: "none",
                }}
                onClick={() => window.open("https://wa.me/96566687847")}
              >
                {t("common:contactBtn")}
              </ContactButton>
            </div>
          </SectionMargin>
          <SectionMargin className="mobile-view">
            <div
              className="d-flex flex-column align-items-center justify-content-center"
              style={{
                background: "#299cf7",
                padding: "40px 20px",
                borderRadius: 20,
              }}
            >
              <ChatIcon style={{ marginBottom: 24 }} />
              <ContactHeaderText arabic={i18n.language === "ar"}>
                {t("common:contactSection")}
              </ContactHeaderText>
              <ContactSubtext arabic={i18n.language === "ar"}>
                {t("common:contactSectionDesc")}{" "}
              </ContactSubtext>
              <ContactButton
                btnType={"light"}
                width="335px"
                style={{
                  marginTop: 24,
                  height: 56,
                  border: "none",
                }}
                onClick={() => window.open("https://wa.me/96566687847")}
              >
                {t("common:contactBtn")}
              </ContactButton>
            </div>
          </SectionMargin>
        </>
      ) : null}

      <Container>
        <SectionMargin className="d-flex flex-column align-items-center justify-content-center">
          <HeaderText
            width="100%"
            textAlign={i18n.language === "ar" ? "right" : "left"}
            arabic={i18n.language === "ar"}
          >
            {t("common:partnerSection")}{" "}
          </HeaderText>
          <PartnerSubtext arabic={i18n.language === "ar"}>
            {t("common:partnerSectionDesc")}
          </PartnerSubtext>
        </SectionMargin>
      </Container>

      <div className="container pc-view" style={{ marginTop: 50 }}>
        <UniversitySlider arabic={i18n.language === "ar"} />
      </div>

      <div className="mobile-view" style={{ marginTop: 40 }}>
        <UniversitySlider arabic={i18n.language === "ar"} />
      </div>

      <Container>
        <SectionMargin>
          <HeaderText
            textAlign={i18n.language === "ar" ? "right" : "left"}
            arabic={i18n.language === "ar"}
          >
            {t("common:faq")}
          </HeaderText>
          <Accordion>
            <FaqComponent
              answer={t("common:faqAnswer1")}
              question={t("common:faqQuestion1")}
              customPadding={""}
              eventKeyProps={"0"}
              arabic={i18n.language === "ar"}
            />
            <FaqComponent
              answer={t("common:faqAnswer2")}
              question={t("common:faqQuestion2")}
              customPadding={""}
              eventKeyProps={"1"}
              arabic={i18n.language === "ar"}
            />
            <FaqComponent
              answer={t("common:faqAnswer3")}
              question={t("common:faqQuestion3")}
              customPadding={""}
              eventKeyProps={"2"}
              arabic={i18n.language === "ar"}
            />
            <FaqComponent
              answer={t("common:faqAnswer4")}
              question={t("common:faqQuestion4")}
              customPadding={""}
              arabic={i18n.language === "ar"}
              eventKeyProps={"3"}
            />
            <FaqComponent
              answer={t("common:faqAnswer5")}
              question={t("common:faqQuestion5")}
              customPadding={""}
              eventKeyProps={"4"}
              arabic={i18n.language === "ar"}
            />
          </Accordion>
        </SectionMargin>
        <SectionMargin></SectionMargin>
      </Container>
      <ContainerArcks />
    </>
  );
}
